import React from 'react';
import { useKeyDownModalEscape } from '@cognitiv/cyprus-ui';
import { useAppDispatch, useAppSelector } from 'ducks/hooks';
import { selectModals } from 'ducks/modals/selectors';
import { setModal } from 'ducks/modals/slices';
import { AdvancedFiltering } from 'modals/advanced-filtering/AdvancedFiltering';
import { ManageScheduleBatch } from 'modals/batches/ManageScheduleBatch';
import { RunBatchDefinition } from 'modals/batches/RunBatchDefinition';
import { RunScheduleBatch } from 'modals/batches/RunScheduleBatch';
import { ScheduleBatchHistory } from 'modals/batches/ScheduledBatchHistory';
import { CreateParameter } from 'modals/create-parameter/CreateParameter';
import { EditJob } from 'modals/job/EditJob';
import { StopJob } from 'modals/job/StopJob';
import { CreateJobDefinition } from 'modals/job-definition/CreateJobDefinition';
import { RunJobDefinition } from 'modals/job-definition/RunJobDefinition';
import { ParameterConnections } from 'modals/parameter-connections/ParameterConnections';
import { CreateProject } from 'modals/project/CreateProject';
import { Errors } from 'modals/utility/Error';
import { Warning } from 'modals/utility/Warning';

export const Modals = () => {
  const dispatch = useAppDispatch();
  const modals = useAppSelector(selectModals);

  useKeyDownModalEscape(modals, (modal_name: string) => {
    dispatch(setModal({ [modal_name]: false }));
  });

  return (
    <>
      <CreateProject />
      <CreateJobDefinition />
      <ScheduleBatchHistory />
      <StopJob />
      <EditJob />
      <RunScheduleBatch />
      <RunBatchDefinition />
      <RunJobDefinition />
      <AdvancedFiltering />
      <ManageScheduleBatch />
      <Errors />
      <ParameterConnections />
      <CreateParameter />
      <Warning />
    </>
  );
};
